import { observer } from 'mobx-react-lite'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { ConsultationActions } from '@/features/jobs/details/components/ConsultationActions'
import { type ConsultationState } from '@/features/jobs/details/consultation-state'

export interface ConsultationActionsContainerProps {
  vm: JobDetailsViewModel
  state: ConsultationState
}

export const ConsultationActionsContainer = observer(
  function ConsultationActionsContainer({
    vm,
    state,
  }: ConsultationActionsContainerProps) {
    return (
      <ConsultationActions
        state={state}
        canJoin={vm.consultationVm.canJoinRoom}
        isJoinPending={vm.consultationVm.roomVm.join.pending}
        onJoin={vm.consultationVm.roomVm.join}
        isPickTimePending={vm.consultationVm.promptForTimeSlotSelection.pending}
        onPickTime={vm.consultationVm.promptForTimeSlotSelection}
        onOpenChat={vm.openChat}
        canClose={Boolean(vm.job.consultation?.canClose)}
        onComplete={vm.requestCloseAsCollaborator}
        canDownloadCalendar={Boolean(
          vm.consultationVm.isConsultationBookedAndActive,
        )}
        isDownloadCalendarPending={
          vm.consultationVm.downloadConsultationCalendar.pending
        }
        onDownloadCalendar={vm.consultationVm.downloadConsultationCalendar}
      />
    )
  },
)
